export const HeaderTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const
export type HeaderTag = (typeof HeaderTags)[number]
export const HeaderTagLevels = ['listview', 'listview-metadata', 'listitem'] as const
export type HeaderTagLevel = (typeof HeaderTagLevels)[number]
export const defaultTitleHeaderTag = 'h2' as HeaderTag
export const defaultHeaderTags = {
  listview: defaultTitleHeaderTag,
  'listview-metadata': 'h3' as HeaderTag,
  listitem: 'h3' as HeaderTag,
}

export const Variants = ['default', 'compact'] as const

export const defaultVariant = 'default'
export const defaultIsSelectable = false
export const defaultTitle = 'List view' as const
export const defaultTotalCount = 3
export const defaultSelectedCount = 0
